module.exports = __webpack_public_path__ + "img/dogecoin-bg.8d52708c.svg";